var map = {
	"./lang-ae.css": [
		"xwhI",
		69
	],
	"./lang-en.css": [
		"D8Rx",
		68
	],
	"./lang-ja.css": [
		"3C5u",
		67
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2MYS";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/css lazy ^\.\/lang\-.*\.css$
// module id = 2MYS
// module chunks = 71